"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const PromptModal = ({ open, title, message, defaultValue = '', placeholder = '', confirmLabel = 'Save', cancelLabel = 'Cancel', onConfirm, onCancel, }) => {
    const [value, setValue] = (0, react_1.useState)(defaultValue);
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (open) {
            setValue(defaultValue);
            setTimeout(() => inputRef.current?.focus(), 0);
        }
    }, [open, defaultValue]);
    if (!open)
        return null;
    const handleConfirm = () => {
        onConfirm(value.trim());
    };
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        }, onClick: onCancel, role: "dialog", "aria-modal": "true", "aria-labelledby": "prompt-modal-title", children: (0, jsx_runtime_1.jsxs)("div", { style: {
                background: 'white',
                borderRadius: 12,
                padding: 24,
                maxWidth: 400,
                width: '90%',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            }, onClick: (e) => e.stopPropagation(), children: [(0, jsx_runtime_1.jsx)("h2", { id: "prompt-modal-title", style: { margin: '0 0 12px 0', fontSize: 18, color: '#333' }, children: title }), (0, jsx_runtime_1.jsx)("p", { style: { margin: '0 0 16px 0', fontSize: 15, color: '#666', lineHeight: 1.5 }, children: message }), (0, jsx_runtime_1.jsx)("input", { ref: inputRef, type: "text", value: value, onChange: (e) => setValue(e.target.value), onKeyDown: (e) => {
                        if (e.key === 'Enter')
                            handleConfirm();
                        if (e.key === 'Escape')
                            onCancel();
                    }, placeholder: placeholder, style: {
                        width: '100%',
                        padding: '10px 12px',
                        marginBottom: 20,
                        border: '1px solid #e0e0e0',
                        borderRadius: 8,
                        fontSize: 15,
                        boxSizing: 'border-box',
                    } }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: 12, justifyContent: 'flex-end' }, children: [(0, jsx_runtime_1.jsx)("button", { type: "button", onClick: onCancel, style: {
                                padding: '10px 20px',
                                border: '1px solid #e0e0e0',
                                borderRadius: 8,
                                background: 'white',
                                cursor: 'pointer',
                                fontSize: 14,
                            }, children: cancelLabel }), (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleConfirm, style: {
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: 8,
                                background: '#333',
                                color: 'white',
                                cursor: 'pointer',
                                fontSize: 14,
                            }, children: confirmLabel })] })] }) }));
};
exports.default = PromptModal;
